export const vsComponentName = "changeJournalViewComponent";
